const Summary = () => {
    window.addEventListener('DOMContentLoaded', () => {
        const article = document.querySelector('.article-post');
        const summaryBlocks = document.querySelectorAll('.summary-nav ul');
        const tags = 'h2,h3,h4,h5,h6';

        if (article) {
            let htags = article.querySelectorAll(tags);

            if (htags.length < 2) {
                summaryBlocks.forEach((summaryBlock) => {
                    summaryBlock.style.display = "none";
                });
            } else {
                htags.forEach((thisItem) => {
                    if (thisItem.closest('.block-excerpt')) {
                        return;
                    }

                    const title = thisItem.innerText.trim();
                    const id = thisItem.id ? thisItem.id : slugify(title);
                    const htag = slugify(thisItem.tagName);
                    const link = `<li class="${htag}"> <a href="#${id}">${title}</a></li>`;

                    thisItem.id = id;

                    summaryBlocks.forEach((summaryBlock) => {
                        summaryBlock.insertAdjacentHTML('beforeend', link);
                    });
                });

                const observer = new IntersectionObserver(
                    (entries) => {
                        entries.forEach((entry) => {
                            const id = entry.target.getAttribute('data-id');
                            const link = document.querySelector(`.summary-nav li a[href="#${id}"]`).parentElement;

                            if (entry.isIntersecting && entry.intersectionRatio > 0) {
                                link.classList.add('is-visible');
                            } else {
                                link.classList.remove('is-visible');
                            }
                        });

                        highlightFirstActive();
                    },
                    { rootMargin: '-90px', threshold: 0.1 }
                );

                const splitTags = tags.split(',');

                splitTags.forEach((tagName) => {
                    const elementTag = article.querySelectorAll(tagName);

                    elementTag.forEach((tag) => {
                        let sectionWrap = document.createElement('section');
                        sectionWrap.setAttribute('data-id', tag.id);
                        sectionWrap.setAttribute('class', 'wrap-section');
                        sectionWrap.dataset.type = tagName;

                        let subordinateElements = nextUntil(tag, tagName);
                        subordinateElements.forEach((subEl) => {
                            sectionWrap.appendChild(subEl);
                        });

                        observer.observe(sectionWrap);

                        tag.insertAdjacentElement('beforebegin', sectionWrap);
                        sectionWrap.insertAdjacentElement('afterbegin', tag);
                    });
                });
            }
        }

        const summaryToggle = document.querySelector('[data-toggle="summary"]');
        const summaryNav = document.querySelector('.summary-nav');

        if (summaryToggle && summaryNav) {
            summaryToggle.addEventListener('click', () => {
                summaryToggle.classList.toggle('actived');
                summaryNav.classList.toggle('show-summary-nav');
            });
        }
    });

    let slugify = function (str) {
        return str
            .toString()
            .normalize('NFKD')
            .toLowerCase()
            .trim()
            .replace(/\s+/g, '-')
            .replace(/[^\w\-]+/g, '')
            .replace(/\-\-+/g, '-');
    };

    let nextUntil = function (elem, selector, filter) {
        let siblings = [];
        elem = elem.nextElementSibling;

        while (elem) {
            if (elem.matches(selector)) break;

            if (filter && !elem.matches(filter)) {
                elem = elem.nextElementSibling;
                continue;
            }

            siblings.push(elem);
            elem = elem.nextElementSibling;
        }

        return siblings;
    };

    const highlightFirstActive = () => {
        const summaryBlocks = document.querySelectorAll('.summary-nav ul');
        summaryBlocks.forEach((summaryBlock) => {
            let firstVisibleLink = summaryBlock.querySelector('.is-visible');

            summaryBlock.querySelectorAll('li').forEach((link) => {
                link.classList.remove('active');
            });

            if (firstVisibleLink) {
                firstVisibleLink.classList.add('active');
            }
        });
    };
};

export default Summary;
